export const DEFAULT_QUOTE_VALIDITY_DAYS = 30
